function initClearableInput(container) {
    const newsletterForms = container.querySelectorAll('[data-clearable-input]');
    newsletterForms.forEach((clearableInput) => {
        const input = clearableInput.querySelector('input');
        const clearIcon = clearableInput.querySelector('[data-clearable-input-icon]');

        if (input && clearIcon) {
            input.addEventListener('input', () => {
                clearIcon.style.display = input.value ? 'block' : 'none';
            });

            clearIcon.addEventListener('click', () => {
                input.value = '';
                input.dispatchEvent(new Event('input'));
                input.dispatchEvent(new Event('keyup'));
                clearIcon.style.display = 'none';
                input.focus();
            });
        }
    });
}

naja.addEventListener('init', () => {
    initClearableInput(document.body);
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
    initClearableInput(event.detail.snippet);
});
